import { useMemo } from 'react';
import ABTestToolService from '../Services/ABTestToolService.v2';
import { AB_TESTS_CONFIG } from '../../static/tests-config';

const NEW_BRANDING_PATHS = [];

interface INewBrandingProps {
    path?: string;
}

export const useNewBranding = ({ path }: INewBrandingProps) => {
    const isPathInNewBrandingList = useMemo(() => {
        if (!path) return false;
        return NEW_BRANDING_PATHS.some(brandingPath => path === brandingPath);
    }, [path]);

    const isInNewBrandingTest = useMemo(() => {
        if (!path) return false;
        const abTestData = ABTestToolService.getVariantPerTestInPage(path);

        return Object.entries(abTestData).some(([testId, variant]) => {
            const testConfig = AB_TESTS_CONFIG[testId];
            return (
                variant && testConfig?.newBrandingVariants?.includes(variant)
            );
        });
    }, [path]);

    const isNewBranding = isPathInNewBrandingList || isInNewBrandingTest;

    return { isNewBranding };
};
